import React from "react";

//import axios from 'axios';
//import qs from "qs"; //post to php w/o file_get_contents('php://input');

import ContactCheck from "./screens/contactCheck";
import ContactNew from "./screens/contactNew";
import ContactConfirm from "./screens/contactConfirm";
import Ticket from "./screens/ticket";
import List from "./screens/list";
import SupportForm from "./screens/supportForm";

// Global styles
import "./styles/Layouts.css";
import "./styles/Interface.css";
import { filter } from "lodash";

export default class App extends React.Component {

  //set false before build
  devMode = false; 
  devServer = "https://consult.videowhisper.com/"; 
  version = "2025.02.06";
  // /wp-admin/admin-ajax.php?action=vws_app
  // /wp-json/video-live-support/v1/

//Test list http://localhost:3000/?contact=1&rep=F93E0Y&list=1 //videowhisper
// http://localhost:3000/?contact=1&confirm=F93E0Y //videowhisper confirm to open new ticket
 //Test new:  http://localhost:3000?ticket=4&contact=4&code=wRVeNp
// Dev tik: http://localhost:3000?ticket=4&contact=4&code=wRVeNp
//Form http://localhost:3000/?form=Register

  constructor(props) {
    super(props);

    this.state = {
      language: "en-us",
      flag: "us",
      cansLoaded: false,
      cans: [],
      openTicket: 0,
      openCode: "",
      openRep: "",
      contactCheck: false,
      contactConfirmed: false,
      server: this.server,
      screen: "contactCheck",
      devMode: this.devMode,
      session: { login: 0, nonce: "", confirmed: false },
      contact: { id: 0, name: "", contact: "", type: "", confirmed: "" },
      balance: 0,
      contact_id: 0,
      ticket_id: 0,
      pin: "",
      confirm: "",
      content_id: 0,
      creator_id: 0,
      config: {
        text: {},
        darkMode: false,
        className: "", //inverted
        backgroundColor: "#EEEEEE", //#333333
      },
    };

    const vwParams = window.VideoWhisperSupport;
    if (vwParams) {
      if (vwParams.server) this.server = vwParams.server;
      if (vwParams.devMode) this.devMode = true;
    }

    if (this.devMode) if (!this.server) this.server = this.devServer;

    console.log("videowhisperSupport", this.version);
    if (!this.server)
      console.log(
        "videowhisperSupport/App Server URL Missing: App requires window.VideoWhisperSupport.server parameter.",
        window.VideoWhisperSupport
      );
    if (this.devMode) console.log("videowhisperSupport/App", this.server);
  }

  appStateUpdate = (newState, update) => {
    if (this.devMode)
      console.log("videowhisperSupport/App appStateUpdate", newState, update);

    this.setState(newState, () => {
      if (update) if (update.screen) this.selectScreen();
    });
  };

  selectScreen() {
    const { state } = this;

    //url parameters
    const urlParams = new URLSearchParams(window ? window.location.search : {});

    var contact_id = urlParams.get("contact"); //contact id number
    const confirm = urlParams.get("confirm"); //contact confirm code
    var code = urlParams.get("code"); //ticket access code
    var rep = urlParams.get("rep"); //representative contact confirm code

    var list = urlParams.get("list"); //list tickets
    var ticket_id = urlParams.get("ticket"); //ticket id number
    var form = urlParams.get("form"); //form name
    var department = urlParams.get("department"); //department name

    //niche
    var content_id = urlParams.get("content"); //ticket for content
    var creator_id = urlParams.get("creator"); //ticket for a creator
    var site_id = urlParams.get("site"); //ticket from site

    //list filters
    var filterContact = urlParams.get("filterContact"); //filter by contact
    var filterContactName = urlParams.get("filterContactName"); //filter by contact name

    //JS embed parameters
    const vwParams = window.VideoWhisperSupport;
    if (vwParams) {
      if (vwParams.contact) if (!contact_id) contact_id = vwParams.contact;
      if (vwParams.rep) if (!rep) rep = vwParams.rep;
      if (vwParams.code) if (!code) code = vwParams.code;
      if (vwParams.list) if (!list) list = vwParams.list;
      if (vwParams.form) if (!form) form = vwParams.form;
      if (vwParams.department) if (!department) form = vwParams.department;
      if (vwParams.ticket) if (!ticket_id) ticket_id = vwParams.ticket;

      //filters
      if (vwParams.filterContact) if (!filterContact) filterContact = vwParams.filterContact;
      if (vwParams.filterContactName) if (!filterContactName) filterContactName = vwParams.filterContactName;
    }

    if (!rep) rep = '';

    if (this.devMode)
      console.log(
        "videowhisperSupport/App selectScreen",
        urlParams.toString(),
        vwParams,
        state
      );

    //open ticket from list
    if (state.openTicket) {
      this.setState({
        ticket_id: state.openTicket,
        pin: state.openCode,
        screen: "ticket",
      });
      return;
    }

    //list
    if (list)
      if (contact_id && (confirm || rep)) {
        //from params
        this.setState({
          contact_id: contact_id,
          confirm: confirm,
          rep: rep,
          filterContact: state.filterContact ? state.filterContact : filterContact, //do not overwrite state
          filterContactName: state.filterContactName ? state.filterContactName : filterContactName,
          screen: "list",
        });
        return;
      } else if (state.contact_id && (state.rep || state.confirm)) {
        //from state
        this.setState({ screen: "list" });
        return;
      }

      //confirm first if code available
      if (contact_id && confirm && !this.state.contact.confirmed) {
        //contact confirm
        this.setState({
          contact_id: contact_id,
          ticket_id: ticket_id,
          confirm: confirm,
          form: form,
          screen: "contactConfirm",
        });
        return;
      }

    if (ticket_id && contact_id && (code || rep)) {
      //ticket
      this.setState(
        {
          ticket_id: ticket_id,
          contact_id: contact_id,
          confirm: confirm,
          pin: code,
          rep: rep,
          screen: "ticket",
        },
        () => {
          if (this.devMode)
            console.log("videowhisperSupport/App selectScreen2", this.state);
        }
      );
      return;
    }

    if (!this.state.contactCheck) {
      //check web login
      this.setState({ form: form, screen: "contactCheck" });
      return;
    }

    if (form && this.state.contact && this.state.contact.confirmed) {
      this.setState({ form: form, screen: "form" }); //update form
      return;
    }

    if (this.state.contact && this.state.contact.confirmed) {
      //create new ticket if contact confirmed
      this.setState({ screen: "ticket", department: department });
      return;
    } else {
      this.setState({
        content_id: content_id,
        creator_id: creator_id,
        site_id: site_id,
        form: form,
        department: department,
        screen: "contactNew",
      }); //or create contact
      return;
    }
  }

  render() {
    const { state } = this;

    var buffer = [];

    if (!this.server) return <div id="appContainer">No server URL is configured.  v:{this.version} d:{this.devMode}</div>;

    switch (
      state.screen // first: contactCheck
    ) {
      case "contactCheck": //ajax
        buffer.push(
          <ContactCheck
            key={state.screen}
            callURL={
              this.server +
              "/wp-admin/admin-ajax.php?action=vws_app&task=contact_login"
            }
            appState={state}
            appStateUpdate={this.appStateUpdate}
          />
        );
        break;

      case "contactNew":
        buffer.push(
          <ContactNew
            key={state.screen}
            callURL={this.server + "/wp-json/video-live-support/v1/contact_new"}
            appState={state}
            appStateUpdate={this.appStateUpdate}
          />
        );
        break;

      case "contactConfirm":
        buffer.push(
          <ContactConfirm
            key={state.screen}
            callURL={
              this.server + "/wp-json/video-live-support/v1/contact_confirm"
            }
            appState={state}
            appStateUpdate={this.appStateUpdate}
          />
        );
        break;

      case "ticket":
        buffer.push(
          <Ticket
            key="Ticket"
            callURL={this.server + "/wp-json/video-live-support/v1/ticket"}
            appState={state}
            appStateUpdate={this.appStateUpdate}
          />
        );
        break;

      case "list":
        buffer.push(
          <List
            key="List"
            callURL={this.server + "/wp-json/video-live-support/v1/list"}
            appState={state}
            appStateUpdate={this.appStateUpdate}
          />
        );
        break;

      case "form":
        buffer.push(
          <SupportForm
            key="Form"
            callURL={this.server + "/wp-json/video-live-support/v1/form"}
            appState={state}
            appStateUpdate={this.appStateUpdate}
          />
        );
        break;

      default:
        if (this.devMode)
          buffer.push(
            <div key="default">
              <h2>DevMode: Screen Not Found</h2>
              <b>{state.screen}</b>
              <br />
              {this.devServer}
            </div>
          );
        else
          buffer.push(
            <div key="default">
              <h2>Good</h2>
              {state.screen}
            </div>
          );
    }

    return <div id="appContainer">{buffer}</div>;
  }
}
